// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"a0a157c9","297":"d326327e","432":"c95c8b96","586":"1528e79f","630":"bc735496","638":"53f7e921","654":"7b00df8a","831":"6fea393a"}[chunkId] + ".chunk.js";
};